export default __webpack_public_path__ + "static/media/GPA_CommunityPowered-new.554b4bbb.jpg";